export class AuditoriaModel {
    idUsuarioActualizacion?: string;
    idUsuarioRegistro?: string;
    fechaActualizacion?: Date;
    fechaRegistro?: Date
}
